<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <template v-if="advanced">
                <a-col :md="8" :sm="24">
                  <a-form-item label="更新说明">
                    <a-input
                      v-model="queryParam.upNotes"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="更新包大小">
                    <a-input
                      v-model="queryParam.upHeSize"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="版本号名称">
                    <a-input
                      v-model="queryParam.versionName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="版本号">
                    <a-input
                      v-model="queryParam.versionCode"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="下载地址">
                    <a-input
                      v-model="queryParam.downloadUrl"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
              </template>
              <a-col :md="advanced ? 24 : 8" :sm="24" v-if="false">
                <span
                  class="table-page-search-submitButtons"
                  :style="submitButtonStyle"
                >
                  <a-button type="primary" @click="handleQuery" class="search-button">
                    <a-icon type="search" />搜索
                  </a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery">
                    重置
                  </a-button>
                  <a-button style="margin-left: 8px" @click="toggleAdvanced">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'" />
                  </a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operations">
          <a-button
            type="primary"
            @click="$refs.createForm.handleAdd()"
            v-hasPermi="['version:version:add']"
            class="add-button"
          >
            <PlusOutlined />新增
          </a-button>
          <a-button
            :disabled="single"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['version:version:edit']"
            class="no-border-button"
          >
            <EditOutlined />修改
          </a-button>
          <a-button
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['version:version:remove']"
            class="no-border-button"
          >
            <DeleteOutlined />删除
          </a-button>
          <!-- <table-setting
            :style="{ float: 'right' }"
            v-model:table-size="tableSize"
            v-model:value="columns"
            :refresh-loading="loading"
            @refresh="getList"
          /> -->
        </div>
        <!-- 增加修改 -->
        <create-form ref="createForm" @ok="getList" />
        <!-- 数据表格 -->
        <div style="margin-top: 20px">
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="columns"
            :data-source="list"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 'max-content' }"
            class="optimized-table"
          >
            <template #createTime="{ record }">
              <span>
                {{ parseTime(record.createTime) }}
              </span>
            </template>
            <template #operation="{ record }">
              <div class="table-action-buttons">
                <a
                  @click="$refs.createForm.handleUpdate(record, undefined)"
                  v-hasPermi="['version:version:edit']"
                  class="edit-link"
                >
                  编辑
                </a>
                <span class="action-divider" v-hasPermi="['version:version:remove']">|</span>
                <a
                  @click="handleDelete(record)"
                  v-hasPermi="['version:version:remove']"
                  class="delete-link"
                >
                  删除
                </a>
              </div>
            </template>
          </a-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第 {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryParam.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :show-total="false"
              @change="changeSize"
            />
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import {
  pageVersionInfo,
  listVersionInfo,
  delVersionInfo,
} from '@/api/app/versionInfo'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'VersionInfo',
  components: {
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
    CreateForm,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        appType: null,
        upNotes: null,
        upHeSize: null,
        upUrlType: null,
        upUrl: null,
        versionName: null,
        versionCode: null,
        upType: null,
        compulsoryUp: null,
        planUpType: null,
        planUpTime: null,
        downloadUrl: null,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
          width: 80,
          customRender: ({ index }) => {
            const { pageNum, pageSize } = this.queryParam
            return (pageNum - 1) * pageSize + index + 1
          }
        },
        /* {
          title: 'ID',
          dataIndex: 'id',
          align: 'center',
        }, */
        {
          title: 'APP类型',
          dataIndex: 'appType',
          align: 'center',
          customRender: function (value) {
            if (value == 0) {
              return '安卓'
            } else if (value == 1) {
              return '苹果'
            } else {
              return '通用'
            }
          },
        },
        /* {
        title: '终端',
        dataIndex: 'appType',
        align: 'center',
        customRender: function (value) {
          if(value==0){
            return '用户端'
          }else if(value==1){
            return '工厂端'
          }
        }
      },*/
        {
          title: '版本号名称',
          dataIndex: 'versionName',
          align: 'center',
        },
        {
          title: '版本号',
          dataIndex: 'versionCode',
          align: 'center',
        },
        {
          title: '更新包大小',
          dataIndex: 'upHeSize',
          align: 'center',
        },
        {
          title: '更新地址类型:',
          dataIndex: 'upUrlType',
          align: 'center',
          customRender: function (value) {
            return value == 1 ? '其它(应用市场)' : '内部'
          },
        },

        {
          title: '更新类型:',
          dataIndex: 'upType',
          align: 'center',
          customRender: function (value) {
            return value == 1 ? '整包更新' : '热更新'
          },
        },
        {
          title: '强制升级否',
          dataIndex: 'compulsoryUp',
          align: 'center',
          customRender: function (value) {
            return value == 1 ? '可跳过' : '强制'
          },
        },
        {
          title: '下载地址',
          dataIndex: 'downloadUrl',
          align: 'center',
        },
        {
          title: '更新说明',
          dataIndex: 'upNotes',
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          slots: { customRender: 'createTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          slots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  created() {
    this.getList()
  },
  computed: {
    submitButtonStyle() {
      return this.advanced ? { float: 'right', overflow: 'hidden' } : {}
    },
  },
  watch: {},
  methods: {
    /** 查询APP版本升级 - 记录信息列表 */
    getList() {
      this.loading = true
      pageVersionInfo(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        appType: undefined,
        upNotes: undefined,
        upHeSize: undefined,
        upUrlType: undefined,
        upUrl: undefined,
        versionName: undefined,
        versionCode: undefined,
        upType: undefined,
        compulsoryUp: undefined,
        planUpType: undefined,
        planUpTime: undefined,
        downloadUrl: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const tempIds = row && row.id ? [...this.ids, row.id] : this.ids
      
      // 计算序号
      let indexText = ''
      if (row && row.id) {
        // 单行删除，找到该行在列表中的索引
        const index = this.list.findIndex((item) => item.id === row.id)
        if (index !== -1) {
          const serialNumber = (this.queryParam.pageNum - 1) * this.queryParam.pageSize + index + 1
          indexText = serialNumber.toString()
        }
      } else if (this.selectedRows && this.selectedRows.length > 0) {
        // 多行删除，计算所有选中行的序号
        const serialNumbers = this.selectedRows.map((item) => {
          const index = this.list.findIndex((listItem) => listItem.id === item.id)
          if (index !== -1) {
            return (this.queryParam.pageNum - 1) * this.queryParam.pageSize + index + 1
          }
          return null
        }).filter((num) => num !== null)
        indexText = serialNumbers.join('、')
      }
      
      if (row && row.id) {
        if (!this.ids.includes(row.id)) {
          this.ids.push(row.id)
        }
      }
      
      this.$confirm({
        title: '确认删除所选中数据?',
        content: indexText ? `选中序号：${indexText}` : '确认删除所选数据?',
        onOk() {
          let data = []
          tempIds.map((id) => data.push({ id: id }))
          return delVersionInfo(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'app/app-version-info/export',
            {
              ...that.queryParam,
            },
            `APP版本升级 - 记录信息_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 80px;
  text-align: right;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 */
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  border-radius: 0 !important;
}

.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-picker) {
  border-radius: 0 !important;
}

.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-select-selector) {
  border-radius: 0 !important;
}

.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input-number) {
  border-radius: 0 !important;
}

/* 全局搜索区域所有输入框去掉圆角 */
.table-page-search-wrapper :deep(.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-picker),
.table-page-search-wrapper :deep(.ant-select-selector),
.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background-color: #F3F3F3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background-color: #F3F3F3 !important;
  color: #101010 !important;
}

.no-border-button[disabled] {
  background-color: #F5F5F5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

.no-border-button[disabled]:hover,
.no-border-button[disabled]:focus {
  background-color: #F5F5F5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165DFF !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

/* 删除按钮颜色 - 红色 */
.table-action-buttons .delete-link {
  color: #ff4d4f !important;
}

.table-action-buttons .delete-link:hover {
  color: #ff7875 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}


.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #FFFFFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165DFF !important;
  border-color: #165DFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #FFFFFF !important;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 1;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 2;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #FFFFFF !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

/* Confirm 弹窗按钮样式 */
:deep(.ant-modal-confirm .ant-btn) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-default) {
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-primary) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
  color: #FFFFFF !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:hover:not(:disabled)) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:focus:not(:disabled)) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:active:not(:disabled)) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}
</style>

<style>
/* Confirm 弹窗按钮样式 - 全局样式确保生效（confirm弹窗是动态创建的） */
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
  color: #FFFFFF !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:focus:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:active:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}
</style>
